import { PageHeader } from '@/components/common/PageHeader';
import { DataGrid } from '@/components/tables/DataGrid';
import type { DataGridColumn } from '@/components/tables/DataGrid';
import { useServerDataTable } from '@/components/tables/useServerDataTable';
import { onlineUsersApi } from '@/api/services/onlineUsers';
import type { OnlineUsersDto } from '@/api/types/onlineUsers';
import { formatDateTime as fmtDateTime } from '@/utils/format';

function formatDateTime(iso?: string | null): string {
  return fmtDateTime(iso);
}

// Host "Online Users": a live snapshot of logged-in users across every tenant.
// The legacy page renders the current snapshot via the app service (a Reload
// table action re-fetches); it does NOT use SignalR, so no live hub is wired.
export function OnlineUsersPage() {
  const table = useServerDataTable<OnlineUsersDto>({
    queryKey: ['onlineUsers', 'list'],
    fetcher: (req) => onlineUsersApi.getListForDataTable(req),
  });

  const columns: DataGridColumn<OnlineUsersDto>[] = [
    // tenantName is Orderable = false in legacy.
    { key: 'tenantName', header: 'Client', cell: (r) => r.tenantName ?? '' },
    { key: 'userName', header: 'User Name', sortable: true, cell: (r) => r.userName ?? '' },
    { key: 'ip', header: 'Ip Address', sortable: true, cell: (r) => r.ip },
    {
      key: 'loginInTime',
      header: 'Login Time',
      sortable: true,
      cell: (r) => formatDateTime(r.loginInTime),
    },
    // sessionDuration is Orderable = false in legacy.
    { key: 'sessionDuration', header: 'Session Duration', cell: (r) => r.sessionDuration },
  ];

  return (
    <div>
      <PageHeader title="Online Users" breadcrumb={['Home', 'Online Users']} />

      <div className="card">
        <div className="card-body">
          <DataGrid
            controller={table}
            columns={columns}
            rowKey={(r) => r.id}
            emptyMessage="No online users found."
            toolbarEnd={
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                title="Reload Table"
                onClick={() => table.refetch()}
              >
                <i className="fa fa-refresh" />
              </button>
            }
          />
        </div>
      </div>
    </div>
  );
}
